import { PageController } from '@client/components/_core/layout/PageController';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { message } from '@client/components/_ui/feedback/message';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { match } from 'ts-pattern';
import { type Category, CategoryForm } from './CategoryForm';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/mspr/definitions/categories/add')({
    component: AddCategory,
    staticData: {
        presentation: 'overlay',
    },
});

function AddCategory() {
    const { trpc, trpcUtils } = useTrpc();
    const [open, setOpen] = useState(true);
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { mutate: createCategory, isPending: isCreating } = trpc.mspr.category.createCategory.useMutation();
    const handleSubmit = (values: Category) => {
        const key = 'create_category';
        message.loading({ content: 'Creating…', key });
        createCategory(
            {
                name: values.name ?? '',
            },
            {
                onSuccess: () => {
                    message.success({ content: 'Category created', key });
                    trpcUtils.mspr.category.listCategories.invalidate();
                    setOpen(false);
                },
                onError: (error) => {
                    errorMessage.show(error);
                },
            },
        );
    };

    return (
        <PageController route={Route}>
            <CategoryForm
                open={open}
                mode="add"
                data={{ name: '' }}
                state={match({ isCreating })
                    .with({ isCreating: true }, () => 'submitting' as const)
                    .otherwise(() => 'ready' as const)}
                onSubmit={handleSubmit}
                onCloseFinished={() => {
                    navigate({ to: '/console/$orgId/configuration/compliance/mspr/definitions', params: { orgId } });
                }}
            />
        </PageController>
    );
}
